module.exports = __webpack_public_path__ + "img/03.5c6241a1.png";